export default __webpack_public_path__ + "static/Multas-a92959cc843c250ac2bc5efc30c4b8ec.png";